import objectPath from 'object-path'

export default {
  props: ['vnode', 'data', 'index', 'defaultValue'],
  name: 'EdoovoTableColumn',
  functional: true,
  /**
   * 优先渲染插槽，其次渲染 props对应的数据，否则渲染默认值
   * @param { function } h render组件的方法
   * @param { object } context 页面context属性，包含各种需要render的属性
   * @returns { void }
   */

  render(h, context) {
    const columnOption = context.props.vnode.componentOptions
    const columnData = context.props.vnode.data

    const columnProps = columnOption.propsData

    if (columnProps.tooltip !== false && typeof columnProps.tooltip !== 'function') {
      columnProps.tooltip = true
    }

    const defaultScopedSlots = context.props.vnode.data.scopedSlots
      ? context.props.vnode.data.scopedSlots.default
      : undefined

    const cellData = { row: context.props.data, $index: context.props.index }

    // 优先使用作用域插槽，否则使用默认插槽
    let children = defaultScopedSlots ? defaultScopedSlots(cellData) : columnOption.children

    const value = objectPath.get(context.props.data, columnProps.prop)
    let text = ''
    if (columnProps.getTooltipText && typeof columnProps.getTooltipText === 'function') {
      text = columnProps.getTooltipText(context.props.data)
    }
    const tooltipText = text || value || ''

    // 如果都没有读取prop对应的值
    if (!children) {
      /** 读取默认值 column上的设置如果有设置，会覆盖 table上的设置 */
      children =
        value === null || value === undefined || value === ''
          ? columnProps.defaultValue || context.props.defaultValue || ''
          : value
      if (columnProps.formatter) {
        children = columnProps.formatter(cellData.row, columnOption, value, cellData.$index)
      }
    }

    const renderChildren = h(
      'div',
      {
        class: `edoovo-table-cell-inner ${columnData.staticClass || ''}`,
        attrs: columnData.attrs,
        style: columnData.style,
        on: Object.keys(columnOption.listeners || {}).reduce(
          (p, key) => ({
            ...p,
            [key](...e) {
              columnOption.listeners[key](cellData, ...e)
            }
          }),
          {}
        )
      },
      children
    )
    // tooltip：tooltip 为真值（或函数返回真值）且 tooltipText 非空且非 object 时包裹。
    // 注意：插槽单元格同样会被包裹（历史行为，见 tests/unit/components/tableColumn.test.js）。
    const tooltip =
      typeof columnProps.tooltip === 'function'
        ? columnProps.tooltip(cellData)
        : columnProps.tooltip

    if (tooltip && typeof tooltipText !== 'object' && !!tooltipText) {
      return h(
        'el-tooltip',
        {
          props: {
            'visible-arrow': false,
            effect: 'light',
            'popper-class': 'edoovo-table-cell-tooltip',
            placement: 'bottom-start',
            content: `${tooltipText}`
          }
        },
        [renderChildren]
      )
    }

    return renderChildren
  }
}
